<template>
    <a-spin tip="Carregando..." :spinning="spinning">
        <div class="container" style="padding-bottom:50px">
            <a-card>
                <template #title>
                    <a-breadcrumb separator=">">
                        <a-breadcrumb-item>
                            <FileOutlined/>
                            <a href="/inspections"><span>Vistorias</span></a>
                        </a-breadcrumb-item>
                        <a-breadcrumb-item>
                            {{ isEditMode ? 'Editar Vistoria' : 'Cadastrar Vistoria' }}
                        </a-breadcrumb-item>
                    </a-breadcrumb>
                </template>
                <div v-if="!subdivisionLoaded">
                    <a-form layout="vertical" :model="subdivision" ref="subdivisionRef" name="subdivisionForm"
                            @finish="mountInspection" @finishFailed="openNotification('error', 'Ainda há campos pendentes')"
                    >
                        <a-row>
                            <a-col :span="6">
                                <a-form-item :name="`propertyId`" label="Inscrição Imobiliária"
                                             :rules="[{required:true, message:'Informe uma inscrição'}]"
                                >
                                    <a-select v-model:value="subdivision.propertyId" show-search :options="propertyIdList" />
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="6">
                                <a-form-item :name="`processCode`" label="Número de protocolo"
                                             :rules="[{required:true, message:'Informe um número de protocolo'}]"
                                >
                                    <a-select v-model:value="subdivision.processCode" style="width: 100%" show-search :options="processCodeList" optionFilterProp="label" />
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col>
                                <a-tooltip title="Gerar vistoria">
                                    <a-button size="large" type="primary" shape="round" :icon="h(PlusOutlined)" html-type="submit" />
                                </a-tooltip>
                            </a-col>
                        </a-row>
                    </a-form>
                </div>
                <div v-else>
                    <a-row>
                        <a-col :span="24">
                            <a-select
                                ref="select"
                                v-model:value="form.status"
                                :class="`status-${form.status}`"
                                style="width: 150px"
                            >
                                <a-select-option value="canceled">Cancelado</a-select-option>
                                <a-select-option value="inProgress">Em andamento</a-select-option>
                                <a-select-option value="completed">Completado</a-select-option>
                                <a-select-option value="migratedData">Dados migrados</a-select-option>
                            </a-select>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="20">
                            <a-page-header title="Vistoria" :sub-title="subdivisionLoaded ? header() : ''" />
                        </a-col>
                        <a-col :span="4" class="center-flex">
                            <a-button @click="addConstruction" :disabled="addConstructionDisabled" type="primary" shape="round" size="large" :icon="h(PlusOutlined)" class="center-flex">
                                Adicionar construção
                            </a-button>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="24">
                            <a-steps :current="current" type="navigation" :items="steps"></a-steps>
                        </a-col>
                    </a-row>
                    <a-form :model="form" ref="formRef" name="inspectionForm" layout="vertical" autocomplete="off"
                            @finish="onFinish" @finishFailed="openNotification('error', 'Ainda há campos pendentes')" class="mt-5"
                    >
                        <a-row style="display:flex; justify-content:end">
                            <a-form-item>
                                <a-tooltip title="Voltar" v-if="current > 0">
                                    <a-button size="large" type="default" shape="round" @click="current--" :icon="h(ArrowLeftOutlined)"
                                              style="margin-right:10px;"/>
                                </a-tooltip>
                                <a-tooltip title="Próximo" v-if="current < steps.length - 1">
                                    <a-button size="large" type="primary" shape="round" @click="stepHandler('next')" :icon="h(ArrowRightOutlined)"/>
                                </a-tooltip>
                                <a-tooltip :title="isEditMode ? 'Salvar Alterações' : 'Criar'"
                                           v-if="current === steps.length - 1">
                                    <a-button size="large" :disabled="submitDisabled" type="primary" shape="round" :icon="h(SaveOutlined)" html-type="submit"/>
                                </a-tooltip>
                            </a-form-item>
                        </a-row>
                        <div v-if="current === 0">
                            <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                                <a-col class="gutter-row" :span="8">
                                    <a-form-item :name="['matriculas', 0]" label="Inscrição Imobiliária"
                                                 :rules="[{required:true, message:'Informe uma inscrição' }]"
                                    >
                                        <a-input-number disabled v-model:value="form.matriculas[0]" style="width: 100%" :min="0" />
                                    </a-form-item>
                                </a-col>
                                <a-col class="gutter-row" :span="8">
                                    <a-form-item :name="`zonaFiscal`" label="Zona Fiscal"
                                                 :rules="[{required:true, message:'Informe uma zona fiscal' }]"
                                    >
                                        <a-input v-model:value="form.zonaFiscal" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col class="gutter-row" :span="8">
                                    <a-form-item :name="`bairro`" label="Bairro"
                                                 :rules="[{required:true, message:'Informe um bairro'}]"
                                    >
                                        <a-input v-model:value="form.bairro" disabled />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                                <a-col class="gutter-row" :span="8">
                                    <a-form-item :name="`dataHora`" label="Data e hora"
                                                 :rules="[{required:true, message:'Informe uma data e hora' }]"
                                    >
                                        <a-config-provider :locale="ptBR">
                                            <a-date-picker format="DD/MM/YYYY HH:mm" show-time v-model:value="form.dataHora" style="width:100%" />
                                        </a-config-provider>
                                    </a-form-item>
                                </a-col>
                                <a-col class="gutter-row" :span="8">
                                    <a-form-item :name="`protocolo`" label="Número de protocolo"
                                                 :rules="[{required:true, message:'Informe um número de protocolo'}]"
                                    >
                                        <a-select v-model:value="form.protocolo" style="width: 100%" show-search :options="processCodeList" optionFilterProp="label"/>
                                    </a-form-item>
                                </a-col>
                                <a-col class="gutter-row" :span="8">
                                    <a-form-item :name="`area`" label="Área m²"
                                                 :rules="[{required:true, message:'Informe uma área'}]"
                                    >
                                        <a-input-number v-model:value="form.area" style="width: 100%"
                                                        :min="0" :max="9999999999999.99" :step="0.01"
                                                        :formatter="val => `${val}`.replace('.', ',')"
                                                        :parser="val => val.replace(',', '.')" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                                <a-col class="gutter-row" :span="8">
                                    <a-form-item :name="`requerente`" label="Requerente"
                                                 :rules="[{required:true, message:'Informe o nome do requerente'}]"
                                    >
                                        <a-input v-model:value="form.requerente" style="width: 100%" :min="0" />
                                    </a-form-item>
                                </a-col>
                                <a-col class="gutter-row" :span="8">
                                    <a-form-item :name="`email`" label="Email do requerente">
                                        <a-input v-model:value="form.email" style="width: 100%" :min="0" />
                                    </a-form-item>
                                </a-col>
                                <a-col class="gutter-row" :span="8">
                                    <a-form-item :name="`telefone`" label="Telefone do requerente"
                                                 :rules="[{required:true, message:'Informe o telefone do requerente'}]"
                                    >
                                        <a-input v-model:value="form.telefone" style="width: 100%" v-mask="'(##) #####-####'" type="tel" :min="0" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                                <a-col class="gutter-row" :span="24">
                                    <a-form-item :name="`observacoes`" label="Observações">
                                        <a-textarea v-model:value="form.observacoes" :rows="4" />
                                    </a-form-item>
                                </a-col>
                            </a-row>

                            <a-divider orientation="left">Características</a-divider>
                            <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                                <template v-for="(caracteristica, idx) in form.caracteristicas" :key="caracteristica.codigo">
                                    <a-col :span="8">
                                        <a-form-item :label="caracteristica.descricao" :name="['caracteristicas', idx, 'selected']">
                                            <a-select v-model:value="caracteristica.selected" size="large">
                                                <a-select-option :key="null" :value="null">Nenhuma</a-select-option>
                                                <a-select-option v-for="opcao of caracteristica.opcoes" :key="opcao.codigo"
                                                                 :value="opcao.codigo">
                                                    {{ opcao.descricao }}
                                                </a-select-option>
                                            </a-select>
                                        </a-form-item>
                                    </a-col>
                                </template>
                            </a-row>

                            <a-divider orientation="left">Imagens do lote</a-divider>
                            <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                                <a-col :span="24">
                                    <a-upload-dragger
                                        v-model:file-list="form.imagensLote"
                                        :before-upload="() => false"
                                        list-type="picture"
                                        accept=".png,.jpg,.jpeg"
                                    >
                                        <p class="ant-upload-drag-icon">
                                            <inbox-outlined />
                                        </p>
                                        <p class="ant-upload-text">Clique ou arraste um arquivo para a área para adicionar</p>
                                        <p class="ant-upload-hint">Suporta arquivos .jpg, .jpeg e .png</p>
                                    </a-upload-dragger>
                                    <a-empty v-if="form.imagensLote.length === 0" style="border-radius:10px; margin:20px" description="Sem imagens do lote" />
                                </a-col>
                            </a-row>
                        </div>


                        <template v-for="(construcao, idx) in form.construcoes" :key="construcao.codigo">
                            <div v-if="current === construcao.step">
                                <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                                    <a-col class="gutter-row" :span="4">
                                        <a-form-item :name="['construcoes', idx, 'baixa']">
                                            <a-checkbox v-model:checked="form.construcoes[idx].baixa">Construção Baixada</a-checkbox>
                                        </a-form-item>
                                    </a-col>
                                    <a-col class="gutter-row" :span="16">
                                        <a-form-item :name="['construcoes', idx, 'construcao_principal']">
                                            <a-checkbox v-model:checked="form.construcoes[idx].construcao_principal" :disabled="form.construcoes[idx].baixa">Construção principal</a-checkbox>
                                        </a-form-item>
                                    </a-col>
                                    <a-col class="gutter-row" :span="4" style="display:flex; justify-content:end">
                                        <a-popconfirm
                                            title="Tem certeza que deseja remover esta construção?"
                                            okText="Remover"
                                            cancelText="Não"
                                            :okButtonProps="{ type: 'primary', danger: true, size: 'default' }"
                                            :cancelButtonProps="{ danger: true, size: 'default' }"
                                            @confirm="removeConstruction(idx)"
                                        >
                                            <template #icon><question-circle-outlined style="color: red" /></template>
                                            <a-button danger type="primary" shape="round" :icon="h(DeleteOutlined)" class="center-flex">
                                                Remover
                                            </a-button>
                                        </a-popconfirm>
                                    </a-col>
                                </a-row>

                                <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                                    <a-col class="gutter-row" :span="6">
                                        <a-form-item :name="['matriculas', construcao.codigo]" label="Inscrição Imobiliária"
                                                     :rules="[{required:true, message:'Informe uma inscrição'}]"
                                        >
                                            <a-input-number v-model:value="form.matriculas[construcao.codigo]" style="width: 100%"
                                                            disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                                    <a-col class="gutter-row" :span="8">
                                        <a-form-item :name="['construcoes', idx, 'logradouro']" label="Logradouro"
                                                     :rules="[{ required: true, message: 'Informe um logradouro' }]"
                                        >
                                            <a-select
                                                ref="select"
                                                v-model:value="form.construcoes[idx].logradouro"
                                                :options="form.ruas"
                                                :disabled="form.construcoes[idx].baixa" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col class="gutter-row" :span="8">
                                        <a-form-item :name="['construcoes', idx, 'numero']" label="Número"
                                                     :rules="[{ required: true, message: 'Informe um número' }]"
                                        >
                                            <a-input-number v-model:value="form.construcoes[idx].numero" style="width:100%"
                                                             min="0" :disabled="form.construcoes[idx].baixa" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col class="gutter-row" :span="8">
                                        <a-form-item :name="['construcoes', idx, 'complemento']" label="Complemento">
                                            <a-input v-model:value="form.construcoes[idx].complemento" :disabled="form.construcoes[idx].baixa" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                                    <a-col class="gutter-row" :span="8">
                                        <a-form-item :name="['construcoes', idx, 'ano_constr']" label="Ano de construção"
                                                     :rules="[{ required: true, message: 'Informe o ano de construção' }]">
                                            <a-input-number v-model:value="form.construcoes[idx].ano_constr" style="width:100%"
                                                            min="0" :disabled="form.construcoes[idx].baixa" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col class="gutter-row" :span="8">
                                        <a-form-item :name="['construcoes', idx, 'data_lancamento']" label="Data de lançamento">
                                            <a-config-provider :locale="ptBR">
                                                <a-date-picker format="DD/MM/YYYY" v-model:value="form.construcoes[idx].data_lancamento"
                                                               :disabled="form.construcoes[idx].baixa" style="width:100%" />
                                            </a-config-provider>
                                        </a-form-item>
                                    </a-col>
                                    <a-col class="gutter-row" :span="8">
                                        <a-form-item :name="['construcoes', idx, 'data_habitese']" label="Data Habite-se">
                                            <a-config-provider :locale="ptBR">
                                                <a-date-picker format="DD/MM/YYYY" v-model:value="form.construcoes[idx].data_habitese"
                                                               :disabled="form.construcoes[idx].baixa" style="width: 100%" />
                                            </a-config-provider>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                                    <a-col class="gutter-row" :span="24">
                                        <a-form-item :name="['construcoes', idx, 'observations']" label="Observações">
                                            <a-textarea v-model:value="form.construcoes[idx].observacoes" :rows="4"
                                                        :disabled="form.construcoes[idx].baixa" style="width: 100%" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>

                                <a-divider orientation="left">Área da Construção</a-divider>
                                <a-row :gutter="30">
                                    <a-col class="gutter-row" :span="8">
                                        <a-form-item :name="['construcoes', idx, 'area_constr']" label="Área da Construção M²"
                                                     :rules="[{ required: true, message: 'Informe a área do m²' }]">
                                            <a-input-number v-model:value="form.construcoes[idx].area_constr" style="width: 100%"
                                                            :min="0" :max="9999999999999.99" :step="0.01" :disabled="form.construcoes[idx].baixa"
                                                            :formatter="val => `${val}`.replace('.', ',')"
                                                            :parser="val => val.replace(',', '.')" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col class="gutter-row" :span="8">
                                        <a-form-item :name="['construcoes', idx, 'pavimento']" label="Pavimentos">
                                            <a-input-number v-model:value="form.construcoes[idx].pavimento" style="width: 100%" :min="0" :disabled="form.construcoes[idx].baixa" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>

                                <a-divider orientation="left">Características da Construção</a-divider>
                                <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                                    <template v-for="caracteristica of construcao.caracteristicas" :key="caracteristica.codigo">
                                        <a-col :span="8">
                                            <a-form-item :label="caracteristica.descricao" :name="['construcoes', idx, 'caracteristicas', getCharIndex(construcao, caracteristica), 'selected']"
                                            >
                                                <a-select v-model:value="caracteristica.selected" size="large" :disabled="form.construcoes[idx].baixa">
                                                    <a-select-option :key="null" :value="null">Nenhuma</a-select-option>
                                                    <a-select-option v-for="opcao of caracteristica.opcoes" :key="caracteristica.codigo"
                                                                     :value="opcao.codigo">
                                                        {{ opcao.descricao }}
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                        </a-col>
                                    </template>
                                </a-row>

                                <a-divider orientation="left">Imagens da Construção {{ construcao.step }}</a-divider>
                                <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                                    <a-col :span="24">
                                        <a-upload-dragger
                                            v-model:file-list="form.construcoes[idx].imagensConstrucao"
                                            :before-upload="() => false"
                                            list-type="picture"
                                            accept=".png,.jpg,.jpeg"
                                            :disabled="form.construcoes[idx].baixa"
                                        >
                                            <p class="ant-upload-drag-icon">
                                                <inbox-outlined />
                                            </p>
                                            <p class="ant-upload-text">Clique ou arraste um arquivo para a área para adicionar</p>
                                            <p class="ant-upload-hint">Suporta arquivos .jpg, .jpeg e .png</p>
                                        </a-upload-dragger>
                                        <a-empty v-if="form.construcoes[idx].imagensConstrucao.length === 0" style="border-radius:10px; margin:20px" :description="`Sem imagens da construção ${construcao.step}`" />
                                    </a-col>
                                </a-row>
                            </div>
                        </template>
                    </a-form>
                </div>
            </a-card>
        </div>
    </a-spin>


</template>

<script setup>
import {h, nextTick, onMounted, reactive, ref} from "vue";
import {InboxOutlined, QuestionCircleOutlined} from "@ant-design/icons-vue";
import dayjs from 'dayjs';
import ptBR from "ant-design-vue/lib/locale/pt_BR";
import {notification} from 'ant-design-vue';
import "codemirror/mode/htmlmixed/htmlmixed";
import "codemirror/theme/neat.css";
import axios from "axios";
import {FileOutlined, SaveOutlined, ArrowRightOutlined, ArrowLeftOutlined, PlusOutlined,
    DeleteOutlined, LayoutOutlined, HomeOutlined} from '@ant-design/icons-vue';
import { openNotification } from "../../../utils/utilities";

const current = ref(0);
const submitDisabled = ref(false);
const addConstructionDisabled = ref(false);
const steps = ref([{title: 'Lote', icon: h(LayoutOutlined)}]);
const props = defineProps(["id"]);
const isEditMode = ref(!!props.id);
const spinning = ref(false);
const propertyIdList = ref([]);
const processCodeList = ref([]);
const subdivisionLoaded = ref(false);
const formRef = ref();
const form = reactive({
    matriculas: ['',],
    zonaFiscal: '',
    ruas: [],
    dataHora: dayjs(),
    observacoes: '',
    protocolo: '',
    bairro: '',
    area: '',
    requerente: '',
    telefone: '',
    email: '',
    imagensLote: [],
    caracteristicas: [],
    construcoes: [],
    status: ''
});

const subdivisionRef = ref();
const subdivision = reactive({
    propertyId: null,
    processCode: null
})

onMounted(async () => {
    spinning.value = true
    processCodeList.value = (await axios.get(`/api/e-cidade/procedure/codes`)).data.map((item) => {
        return {
            value: item.p58_codproc,
            label: `${item.p58_numero}/${item.p58_ano}`,
        }
    })
    if (!!props.id) {
        try {
            const response = (await axios.get(`/api/inspections/${props.id}`)).data.data
            subdivision.propertyId = response['matricula']
            subdivision.processCode = response['protocolo']

            processResponse(response)

            subdivisionLoaded.value = true
        } catch (error) {
            spinning.value = false
            openNotification('error', error.message)
        }
    } else {
        propertyIdList.value = (await axios.get(`/api/inspections/propertyid-list`)).data.data
    }

    spinning.value = false
})

const onFinish = async () => {
    spinning.value = true
    submitDisabled.value = true
    let processCode = null;
    if (props.id) {
        processCode = processCodeList.value.find(pr => pr.label === form.protocolo)

        if (!processCode) {
            processCode = processCodeList.value.find(pr => pr.value === form.protocolo)
        }
    } else {
        processCode = processCodeList.value.find(pr => pr.label === subdivision.processCode)

        if (!processCode) {
            processCode = processCodeList.value.find(pr => pr.value === subdivision.processCode)
        }
    }

    form.protocolo = {
        procedure_number: processCode.label,
        procedure_id: processCode.value
    }

    try {
        const formData = new FormData()
        form.telefone = form.telefone.replace(/\D/g, '')
        const formClone = {
            ...form,
            construcoes: form.construcoes.map(construcao => {
                const { imagensConstrucao, ...resto } = construcao
                return { ...resto }
            })
        }
        delete formClone.imagensLote

        formData.append('form', JSON.stringify(formClone))

        form.imagensLote.forEach(file => {
            if (!!props.id && !file.status) {
                formData.append(`imagensLote[novas][]`, file.originFileObj)
            } else if (!!props.id && file.status) {
                formData.append(`imagensLote[existentes][]`, file.name)
            } else {
                formData.append(`imagensLote[]`, file.originFileObj)
            }
        })

        form.construcoes.forEach((construcao, index) => {
            construcao.imagensConstrucao.forEach(file => {
                if (!!props.id && !file.status) {
                    formData.append(`imagensConstrucoes[${index}][novas][]`, file.originFileObj)
                } else if (!!props.id && file.status) {
                    formData.append(`imagensConstrucoes[${index}][existentes][]`, file.name)
                } else {
                    formData.append(`imagensConstrucoes[${index}][]`, file.originFileObj)
                }
            })
        })

        let response = null
        if (!!props.id) {
            formData.append('_method', 'PUT');
                response = (await window.axios.post(`/api/inspections/${props.id}`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })).data
        } else {
                response = (await window.axios.post(`/api/inspections`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })).data
        }

        openNotification('success', response.message)
        spinning.value = false
        await (new Promise(resolve => setTimeout(resolve, 500)));
        window.location.href = `/inspections`
    } catch (error) {
        spinning.value = false
        submitDisabled.value = false
        openNotification('error', error.response.data.message)
    }
}

const mountInspection = async () => {
    spinning.value = true

    try {
        const response = (await window.axios.get(`/api/inspections/${subdivision.propertyId}/get-info`)).data.data
        processResponse(response)
        subdivisionLoaded.value = true
        spinning.value = false
    } catch (error) {
        openNotification('error', 'Inscrição inexistente, favor verificar.')
    }

    spinning.value = false
}

const processResponse = (response) => {
    if (!!props.id) {
        form.dataHora = dayjs(response['dataHora'])
        form.imagensLote = response['imagensLote']
        form.status = response['status']
    } else {
        form.dataHora = dayjs()
        form.imagensLote = []
        form.status = 'inProgress'
    }

    form.requerente = response['requerente']
    form.telefone = response['telefone']
    form.email = response['email']
    form.matriculas[0] = subdivision.propertyId
    form.zonaFiscal = response['zonaFiscal']
    form.observacoes = response['observacoes']
    form.protocolo = subdivision.processCode
    form.bairro = response['bairro']
    form.area = response['area']
    form.caracteristicas = response['caracteristicasLote']
    form.ruas = response['ruas'].sort((a, b) => (b.principal === true) - (a.principal === true))

    response['construcoes'].forEach((construcao) => {
        let codigo = steps.value.length

        steps.value.push({title: `Construção ${codigo}`, icon: h(HomeOutlined)})
        form.construcoes.push({
            codigo: codigo,
            canFill: false,
            caracteristicas: mountGrupoConstrucao(objectToArray(construcao.caracteristicas)),
            step: codigo,
            imagensConstrucao: construcao.imagensConstrucao ?? [],
            construcao_principal: (construcao.baixa) ? !construcao.baixa : construcao.principal,
            logradouro: form.ruas[0],
            numero: construcao.numero,
            complemento: construcao.complemento,
            ano_constr: construcao.ano_constr,
            data_lancamento: construcao.data_lancamento ? dayjs(construcao.data_lancamento) : null,
            data_habitese: construcao.data_habitese ? dayjs(construcao.data_habitese) : null,
            area_constr: construcao.area,
            pavimento: construcao.pavimento,
            observacoes: construcao.observacoes,
            baixa: construcao.baixa
        })
    });


    while (form.matriculas.length < form.construcoes.length + 1) {
        form.matriculas.push(form.matriculas[0])
    }
}

const addConstruction = async () => {
    addConstructionDisabled.value = true

    if (steps.value.length - 1 === 5) {
        openNotification('error', 'Numero máximo de construções')
        return
    }

    const data = (await window.axios.get('/api/inspections/characteristics/getAll')).data

    let codigo = steps.value.length

    steps.value.push({title: `Construção ${codigo}`, icon: h(HomeOutlined)})
    form.matriculas.push(form.matriculas[0])
    form.construcoes.push({
        codigo: codigo,
        caracteristicas: mountGrupoConstrucao(objectToArray(data.constructCharacteristics)),
        step: codigo,
        imagensConstrucao: [],
        construcao_principal: false,
        logradouro: form.ruas.find(rua => rua.principal).value,
        numero: '',
        complemento: '',
        ano_constr: '',
        data_lancamento: null,
        data_habitese: null,
        area_constr: '',
        pavimento: null,
        observacoes: '',
        baixa: false
    })

    if (await validateForm('noVisual')) { current.value++ }

    openNotification('success', "Construção criada com sucesso!")

    addConstructionDisabled.value = false
}

const removeConstruction = (position) => {
    steps.value.splice(position + 1, 1)
    form.matriculas.splice(position + 1, 1)
    form.construcoes.splice(position, 1)

    steps.value.forEach((step, index) => {
        if (index > position) {
            step.title = "Construção " + index
        }
    })

    form.construcoes.forEach(construcao => {
        if (construcao.step > position && construcao.step !== position + 1) {
            construcao.codigo--
            construcao.step--
        }
    })

    current.value--
}

const mountGrupoConstrucao = (grupos) => {
    let caracteristicas = [];
    grupos.forEach((grupo) => {
        let opcoes = objectToArray(grupo.opcoes);

        caracteristicas.push({
            codigo: grupo.codigo,
            descricao: grupo.descricao,
            opcoes: opcoes,
            selected: (grupo.selected) ? grupo.selected : getSelectedGroup(opcoes)
        });
    });

    return caracteristicas;
}

const header = () => {
    return `#Inscrição nº ${form.matriculas[0]} - vistoria criada em ${form.dataHora.format('DD/MM/YYYY')}`;
}

const objectToArray = (object) => {

    if (typeof object === 'object') {
        return Object.keys(object).map((key) => object[key]);
    }
    return object;
}

const getSelectedGroup = (opcoes) => {
    let value = null;
    opcoes.forEach((opcao) => {
        if (opcao.hasOwnProperty('vistoriado')) {
            value = opcao.codigo;
        }
    });
    return value;
}

const getCharIndex = (construcao, caracteristica) => {
    return construcao.caracteristicas.findIndex(c => c.codigo === caracteristica.codigo);
}

const stepHandler = async (action) => {
    if (await validateForm()) {
        await nextTick();
        switch (action) {
            case 'prev': current.value--; break;
            case 'next': current.value++; break;
        }
    } else {
        openNotification('error', "É preciso preencher todos os campos obrigatórios para avançar")
    }
}

const validateForm = async (option) => {
    try {
        await formRef.value.validateFields();
        return true
    } catch (errorInfo) {
        if (option === 'noVisual') { formRef.value.clearValidate(); }
        return false
    }
}
</script>

<style scoped>
.center-flex {
    display: flex;
    justify-content: center;
    align-items: center;
}

.label {
    font-size: 12px !important;
    font-weight: bolder;
}

.steps-action {
    margin-top: 15px;
    text-align: right;
}

.anticon {
    vertical-align: 0 !important;
}

.status-inProgress :deep(.ant-select-selector) {
    background-color: #fff7e6;
    border-color: #ffc53d;
}
.status-completed :deep(.ant-select-selector) {
    background-color: #e6f7ff;
    border-color: #1890ff;
}
.status-canceled :deep(.ant-select-selector) {
    background-color: #fff1f0;
    border-color: #ff4d4f;
}
.status-migratedData :deep(.ant-select-selector) {
    background-color: #f6ffed;
    border-color: #52c41a;
}

::v-deep(.ant-upload.ant-upload-drag) {
    height: auto !important;
    min-height: auto !important;
    padding: 8px;
}

::v-deep(.ant-upload-list-item-name) {
    color: inherit !important;
    text-decoration: none !important;
    pointer-events: none;
}

</style>
